import { getAmbulance, getBenData, getTickets } from "../../../Http/Index";


export const fetchAmbulance = async (queryParams: any) => {
    try {
        let query: string = "";
        for (const key in queryParams) {
            query += `${key}=${queryParams[key]}&`;
        }
        const res = await getAmbulance(query);
        return res?.data;
    } catch (error) {
        console.log('error:', error);
    }
};

export const fetchBeneficiaries = async (queryParams: any) => {
    try {
        let companyId: string = queryParams.companyId || "";
        const res = await getBenData(companyId);
        return res?.data?.data;
    } catch (error) {
        console.log('error:', error);
    }
};

export const fetchTickets = async (queryParams: any) => {
    try {
        let query: string = "";
        for (const key in queryParams) {
            query += `${key}=${queryParams[key]}&`;
        }
        const res = await getTickets(query);
        return res?.data;
    } catch (error) {
        console.log('error:', error);
    }
};